import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
export function Hero() {
  const words = ['Bestandsgebäude', 'Wohngebäude', 'Altbauten', 'Neubauten', 'Ihr Zuhause'];
  const [wordIndex, setWordIndex] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setWordIndex(prev => (prev + 1) % words.length);
    }, 2200);
    return () => clearInterval(interval);
  }, []);
  return <section className="relative min-h-screen flex flex-col justify-center pt-32 pb-12 overflow-hidden bg-secondary" data-id="element-224">
      <div className="max-w-7xl mx-auto px-6 md:px-12 w-full flex flex-col gap-16" data-id="element-225">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="z-10 flex flex-col items-center text-center max-w-4xl mx-auto" data-id="element-226">
          <div className="inline-block mb-6 px-3 py-1 bg-sage rounded-full text-xs font-medium tracking-wider text-accent/80 uppercase" data-id="element-227">
            Architektur & Energieberatung
          </div>
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-serif leading-[1.1] text-accent mb-6 text-balance" data-id="element-228">
            Energieberatung für{' '}
            <span className="relative inline-block align-baseline" data-id="element-229">
              <AnimatePresence mode="wait" data-id="element-230">
                <motion.span key={words[wordIndex]} initial={{
                opacity: 0,
                y: 20
              }} animate={{
                opacity: 1,
                y: 0
              }} exit={{
                opacity: 0,
                y: -20
              }} transition={{
                duration: 0.5,
                ease: 'easeOut'
              }} className="inline-block text-primary italic" data-id="element-231">
                  {words[wordIndex]}
                </motion.span>
              </AnimatePresence>
            </span>{' '}
            <br className="hidden md:block" data-id="element-232" />– nachhaltig, verständlich und
            individuell.
          </h1>
          <p className="text-lg md:text-xl text-accent/70 mb-10 font-light leading-relaxed max-w-2xl mx-auto" data-id="element-233">
            Ich begleite Eigentümerinnen und Eigentümer dabei, ihre Gebäude
            energetisch sinnvoll weiterzuentwickeln – mit fachlicher Klarheit,
            Fördermittelwissen und einem Blick für den Menschen hinter dem
            Gebäude.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center w-full sm:w-auto" data-id="element-234">
            <a href="#kontakt" className="inline-flex items-center justify-center px-8 py-4 bg-accent text-secondary rounded hover:bg-primary transition-colors duration-300 font-medium group" data-id="element-235">
              Kostenloses Erstgespräch anfragen
              <ArrowRightIcon size={18} className="ml-2 group-hover:translate-x-1 transition-transform" data-id="element-236" />
            </a>
            <a href="#leistungen" className="inline-flex items-center justify-center px-8 py-4 bg-transparent border border-accent/20 text-accent rounded hover:bg-accent/5 transition-colors duration-300 font-medium" data-id="element-237">
              Leistungen ansehen
            </a>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.2,
        ease: 'easeOut'
      }} className="relative h-[50vh] md:h-[60vh] lg:h-[70vh] w-full rounded-2xl overflow-hidden shadow-2xl" data-id="element-238">
          <div className="absolute inset-0 bg-accent/10 z-10 pointer-events-none" data-id="element-239"></div>
          <video src="https://cdn.magicpatterns.com/uploads/tUkBeLcFS4ZBHtxt1gujJ1/A%20modern%20architectural%20illustration%20style%20animation%20showing%20a%20detached%20single-family%20house%20undergoing%20energy-efficient%20renovation%20through%20fluid%20transformations.%20Stylized%20but%20realistic%20proportions,%20high-quality%20.mp4" autoPlay loop muted playsInline title="Animation einer energetischen Gebäudesanierung" aria-label="3D-Animation eines Einfamilienhauses, das energetisch saniert und mit Solarpaneelen ausgestattet wird" className="w-full h-full object-cover object-center" data-id="element-240" />
        </motion.div>
      </div>
    </section>;
}